var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-not-found"},[_c('div',{staticClass:"container text-center"},[_c('img',{staticClass:"mt-4 mb-4",attrs:{"src":"//www.sta.co.uk/wp-content/themes/sta/assets/images/desktop_branding_logo.png","height":"130"}}),_c('h1',[_vm._v("404")]),_c('p',[_vm._v("The page you were looking for could not be found.")])])])
}]

export { render, staticRenderFns }